import gql from 'graphql-tag'
import client from '@stores/apollo'
const UNSEATED = 'UNSEATED'
const unseatedEmployeeCatalog = async (
  assignmentPlanId: string,
  geoLocationId: string | undefined,
  after: string | undefined,
  checked: boolean
) => {
  return client.gql
    .query({
      query,
      variables: {
        assignmentPlanId,
        after,
        ValueFilter: [UNSEATED],
        keyValueFilters: checked ? [{ key: 'GeoLocationId', value: geoLocationId }] : [],
      },
    })
    .then((data) => data.data)
}

const query = gql`
  query unseatedEmployeeCatalog(
    $assignmentPlanId: ID
    $ValueFilter: [FilterEnum]
    $keyValueFilters: [EmployeeKeyValueFiltersInput]
    $after: String
  ) {
    viewer {
      company {
        employees(
          AssignmentPlanId: $assignmentPlanId
          keyValueFilters: $keyValueFilters
          ValueFilter: $ValueFilter
          order: ASC
          sortBy: first_name
          first: 50
          after: $after
        ) {
          pageInfo {
            endCursor
            hasNextPage
          }
          edges {
            node {
              ... on Employee {
                id
                name
                startDate
                endDate
                isRemote
                noDeskNeeded
                assets {
                  url(style: "thumbnail")
                }
                dept {
                  id
                  color
                  name
                }
                team {
                  id
                  color
                  name
                }
                neighborhoods {
                  id
                  name
                  color
                }
              }
            }
          }
        }
      }
    }
  }
`
export default unseatedEmployeeCatalog
